import React from 'react';
import { HiChevronDown } from 'react-icons/hi';

const Select = ({ 
  label, 
  options = [], 
  value, 
  onChange, 
  placeholder = "Select an option", 
  className = "", 
  disabled = false,
  required = false,
  id
}) => {
  return (
    <div className={`w-full ${className}`}>
      {label && (
        <label 
          htmlFor={id} 
          className="block mb-1.5 text-sm font-semibold text-gray-700"
        >
          {label} {required && <span className="text-red-500">*</span>}
        </label>
      )}
      <div className="relative group">
        <select
          id={id}
          value={value}
          onChange={(e) => onChange && onChange(e)}
          disabled={disabled}
          required={required}
          className="w-full px-4 py-2.5 rounded-xl border border-gray-200 bg-white text-gray-900 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500 transition-all appearance-none disabled:bg-gray-50 disabled:text-gray-400 disabled:cursor-not-allowed group-hover:border-gray-300"
        >
          {placeholder && (
            <option value="" disabled={required}>
              {placeholder}
            </option>
          )}
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none text-gray-400 group-hover:text-gray-500 transition-colors">
          <HiChevronDown className="text-lg" />
        </div>
      </div>
    </div>
  );
};

export default Select;
